export default __webpack_public_path__ + "static/media/3 CCTV CAMERA.da8254f8.png";